// FLEX商品カードの画像スライダー（snippets/flex-product-card.liquid）
//
// カードごとに初期化せず document へのイベント委譲で処理する。
// カスタム要素の定義後にパーサーが <flex-media-slider> を読むと、開始タグの時点で
// 昇格するため connectedCallback では子要素（トラック・ドット）がまだ取得できず、
// 2枚目以降のカードが初期化されない問題があったため。
// 委譲方式なら MOREボタンやフィルターで後から追加されたカードにも効く。
(function () {
  const SLIDER = 'flex-media-slider';
  const THRESHOLD = 30;

  function goTo(slider, index) {
    const track = slider.querySelector('.flex-card__media-track');
    if (!track) return;

    const count = track.children.length;
    const next = Math.min(Math.max(index, 0), count - 1);

    track.style.transform = 'translateX(-' + next * 100 + '%)';
    slider.dataset.slideIndex = String(next);
    slider.querySelectorAll('.flex-card__media-dot').forEach((dot, i) => {
      dot.classList.toggle('is-active', i === next);
    });
  }

  document.addEventListener('click', (event) => {
    const dot = event.target.closest('.flex-card__media-dot');
    if (!dot) return;

    const slider = dot.closest(SLIDER);
    if (!slider) return;

    event.preventDefault();
    event.stopPropagation();
    goTo(slider, Number(dot.dataset.index));
  });

  // スマホのスワイプ操作
  let slider = null;
  let startX = 0;
  let startY = 0;
  let deltaX = 0;
  let swiped = false;

  document.addEventListener(
    'touchstart',
    (event) => {
      const link = event.target.closest('.flex-card__media-link');
      slider = link ? link.closest(SLIDER) : null;
      if (!slider) return;

      const touch = event.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
      deltaX = 0;
      swiped = false;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchmove',
    (event) => {
      if (!slider) return;

      const touch = event.touches[0];
      deltaX = touch.clientX - startX;
      if (Math.abs(deltaX) > Math.abs(touch.clientY - startY) && Math.abs(deltaX) > 10) {
        swiped = true;
      }
    },
    { passive: true }
  );

  document.addEventListener('touchend', () => {
    if (slider && swiped && Math.abs(deltaX) >= THRESHOLD) {
      const current = Number(slider.dataset.slideIndex || 0);
      goTo(slider, current + (deltaX < 0 ? 1 : -1));
    }
    slider = null;
  });

  // スワイプ直後のタップで商品ページへ遷移させない
  document.addEventListener(
    'click',
    (event) => {
      if (!swiped) return;
      if (event.target.closest('.flex-card__media-link')) event.preventDefault();
      swiped = false;
    },
    true
  );
})();
